module.exports = __webpack_public_path__ + "img/not-approved.b6a6167d.svg";